import FetchBase from '../Api/FetchBase'
import { observable, action } from 'mobx'
import { API_ENDPOINTS, DEFAULT_PAGE_START } from '../Utils/constants'
import { getUtcUnixDate, getStartDate } from '../Utils/rules'

export default class ProjectBudgetWidgetStore extends FetchBase {
  @observable ordering = undefined
  @observable orderingBy = undefined

  @observable LineItemSearchText = ''
  @observable lineItemsFilters = {}
  @observable LineItemList = []
  @observable totalListItem = 0
  @observable pfSelectedDateChoice = undefined
  @observable listItemPageNo = DEFAULT_PAGE_START
  @observable mediaCentricUsersLoader = true
  @observable selectedCustomerId = undefined
  @observable searchTextForUsersList = undefined
  @observable usersFilters = {}

  @observable ordering = undefined
  @observable orderBy = undefined

  @observable importUsers = []
  @observable importUsersFailures = []
  @observable importUserFromFileLoader = false
  @observable projectLine = []
  @observable projectLineFilter = []
  @observable projectLineFilterforItem = []

  @observable addActionItemLoader = false

  @action.bound
  setOrdering = (value = undefined) => {
    this.ordering = value
  }

  @action.bound
  setOrderingBy = (value = undefined) => {
    this.orderingBy = value
  }

  @action.bound
  SetListItemPageNo = (value = DEFAULT_PAGE_START) => {
    this.listItemPageNo = value
  }

  @action.bound
  setLineItemFilters = (values = {}) => {
    this.lineItemsFilters = values
  }

  @action.bound
  setLineItemSearchText = (value = '') => {
    this.LineItemSearchText = value
  }

  @action.bound
  setSelectedCustomerId = (id) => {
    this.selectedCustomerId = id
  }
  @action.bound
  setSelectedDateChoice = (value) => {
    this.pfSelectedDateChoice = value
  }

  @action.bound
  generateLineItemFilters = () => {
    let tempgenerateLineItemFilters = {}

    let keys = Object.keys(this.lineItemsFilters || {})
    for (let filter of keys) {
      if (this.lineItemsFilters[filter] !== undefined) {
        tempgenerateLineItemFilters[filter] = this.lineItemsFilters[filter]
      }
    }
    this.LineItemSearchText &&
      (tempgenerateLineItemFilters['search'] = this.LineItemSearchText)
    this.ordering && (tempgenerateLineItemFilters['ordering'] = this.ordering)
    this.ordering && (tempgenerateLineItemFilters['orderBy'] = this.orderingBy)
    return tempgenerateLineItemFilters
  }

  @action.bound
  getFilters = () => {
    let tempgetFilters = {}
    if (this.ordering) {
      tempgetFilters['ordering'] = this.ordering
      tempgetFilters['orderBy'] = this.orderingBy
    }
    return tempgetFilters
  }

  // EXPORT REMAINING FROM BACKEND
  @action.bound
  getAllLineItemsExport = async (
    projectId,
    { exportFileType = 'csv' } = {}
  ) => {
    try {
      let options = this.generateLineItemFilters()
      options['exportFileType'] = exportFileType
      let response = await this.post(API_ENDPOINTS.EXPORT_PROJECT_LINE, {
        projectId,
        ...options,
      })
      if (response.status) {
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    }
  }

  @action.bound
  listLineItem = async (projectId) => {
    try {
      this.mediaCentricUsersLoader = true
      let options = this.generateLineItemFilters() || {}
      options['pageLimit'] = '0'
      this.searchTextForUsersList &&
        (options['search'] = this.searchTextForUsersList)
      let response = await this.post(API_ENDPOINTS.LIST_PROJECT_LINE_ITEM, {
        projectId,
        ...options,
      })
      if (response.status) {
        this.projectLineFilterforItem = response.data.lineItemDropdownData
        this.LineItemList = response.data.projectBudgetLineItems
        this.totalListItem = response.data.total
        return true
      }
      this.LineItemList = []

      return false
    } catch (err) {
      this.LineItemList = []

      return false
    } finally {
      this.mediaCentricUsersLoader = false
    }
  }

  @action.bound
  listLineItemforDashboard = async (projectId) => {
    try {
      this.mediaCentricUsersLoader = true
      let options = this.generateLineItemFilters() || {}
      options['pageNo'] = Math.max(this.listItemPageNo - 1, 0)
      options['pageLimit'] = '20'
      this.searchTextForUsersList &&
        (options['search'] = this.searchTextForUsersList)
      let response = await this.post(API_ENDPOINTS.LIST_PROJECT_LINE_ITEM, {
        projectId,
        ...options,
      })
      if (response.status) {
        this.LineItemList = response.data.projectBudgetLineItems
        this.totalListItem = response.data.total
        return true
      }
      this.LineItemList = []

      return false
    } catch (err) {
      this.LineItemList = []

      return false
    } finally {
      this.mediaCentricUsersLoader = false
    }
  }

  @action.bound
  listLineItemforFilter = async (projectId) => {
    try {
      this.mediaCentricUsersLoader = true
      let filters = this.getFilters()
      let options = this.generateLineItemFilters()
      options['pageLimit'] = '0'

      let response = await this.post(API_ENDPOINTS.LIST_PROJECT_LINE_ITEM, {
        projectId,
        ...options,
      })
      if (response.status) {
        this.LineItemList = response.data.projectBudgetLineItems
        this.totalListItem = response.data.total
        return true
      }
      this.LineItemList = []

      return false
    } catch (err) {
      this.LineItemList = []

      return false
    } finally {
      this.mediaCentricUsersLoader = false
    }
  }

  @action.bound
  getLineConfig = async () => {
    try {
      let options = {}
      options['pageLimit'] = '0'
      this.projectTeamLoader = true
      let response = await this.get(API_ENDPOINTS.LIST_LINE_ITEM, options)
      if (response.status) {
        this.projectLine = response.data.budgetLineItems
        return [response.status, response.data.budgetLineItems]
      }
      this.projectLine = []
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    } finally {
      this.projectTeamLoader = false
    }
  }

  @action.bound
  getLineForFilter = async () => {
    try {
      this.projectTeamLoader = true
      let response = await this.get(API_ENDPOINTS.GET_LINE_ITEM_DROPDOWN, {})
      if (response.status) {
        this.projectLineFilter = response.data
        return [response.status, response.data]
      }
      this.projectLineFilter = []
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    } finally {
      this.projectTeamLoader = false
    }
  }

  @action.bound
  listLineItemforFilterofDashboard = async (projectId) => {
    try {
      this.mediaCentricUsersLoader = true
      let filters = this.getFilters()
      let options = this.generateLineItemFilters()
      options['pageLimit'] = '20'

      let response = await this.post(API_ENDPOINTS.LIST_PROJECT_LINE_ITEM, {
        projectId,
        ...options,
      })
      if (response.status) {
        this.LineItemList = response.data.projectBudgetLineItems
        this.totalListItem = response.data.total
        return true
      }
      this.LineItemList = []

      return false
    } catch (err) {
      this.LineItemList = []

      return false
    } finally {
      this.mediaCentricUsersLoader = false
    }
  }

  @action.bound
  deleteLineItem = async (id) => {
    try {
      let response = await this.post(API_ENDPOINTS.DELETE_PROJECT_LINE, {
        id: id,
      })
      if (response.status) {
        return [response.status, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    }
  }

  @action.bound
  deleteBulklineitem = async (id) => {
    try {
      let response = await this.post(API_ENDPOINTS?.BULK_DELETE_PROJECT_LINE, {
        ids: id,
      })
      if (response.status) {
        return [true, response?.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    }
  }

  // Add Line Item
  @action.bound
  addLineItem = async (values) => {
    try {
      this.addActionItemLoader = true
      let response = await this.post(
        API_ENDPOINTS.ADD_PROJECT_LINE_ITEM,
        values
      )
      if (response.status) {
        return [response.status, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    } finally {
      this.addActionItemLoader = false
    }
  }

  @action.bound
  getLineItem = async (id, projectId) => {
    try {
      this.addActionItemLoader = true
      let response = await this.get(API_ENDPOINTS.GET_PROJECT_LINE_BY_ID, {
        id,
        projectId,
      })
      if (response.status) {
        this.actionItem = response?.data
        return [true, response.data]
      }
      this.actionItem = {}
      return [false, undefined]
    } catch (err) {
      this.actionItem = {}
      return [false, undefined]
    } finally {
      this.actionItemLoader = false
    }
  }

  @action.bound
  updateLineItem = async (id, values) => {
    try {
      this.addActionItemLoader = true
      let response = await this.post(API_ENDPOINTS.UPDATE_PROJECT_LINE_ITEM, {
        id,
        ...values,
      })
      if (response.status) {
        return [response.status, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    } finally {
      this.addActionItemLoader = false
    }
  }

  @action.bound
  resetFilterForm = () => {
    this.lineItemsFilters = {}
    this.pfSelectedDateChoice = undefined
  }

  @action.bound
  importUsersFromFileReset = async () => {
    this.importUsers = []
    this.importUsersFailures = []
  }

  @action.bound
  resetUserFilters = () => {
    this.usersFilters = {}

    this.ordering = undefined
    this.orderBy = undefined
  }

  @action.bound
  resetStore = () => {
    this.LineItemSearchText = ''
    this.lineItemsFilters = {}
    this.LineItemList = []
    this.totalListItem = 0
    this.pfSelectedDateChoice = undefined
    this.listItemPageNo = DEFAULT_PAGE_START
    this.mediaCentricUsersLoader = true
    this.selectedCustomerId = undefined
    this.searchTextForUsersList = undefined
    this.usersFilters = {}
    this.ordering = undefined
    this.orderBy = undefined
    this.addActionItemLoader = false
    this.projectLine = []
    this.projectLineFilter = []
    this.projectLineFilterforItem = []
    this.orderingBy = undefined

    this.importUsers = []
    this.importUsersFailures = []
    this.importUserFromFileLoader = false
  }
}
